/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaCircleUser } from "react-icons/fa6";
import { RiListSettingsLine } from "react-icons/ri";
import { TbTargetArrow } from "react-icons/tb";
import { PiHandHeart } from "react-icons/pi";
import { SiWindows } from "react-icons/si";
import { IoIosFitness } from "react-icons/io";
import { MdPayments, MdSubscriptions } from "react-icons/md";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";
import { useTheme } from "next-themes";
import { GiProfit } from "react-icons/gi";

const Sidebar = ({ isSidebarCompress, toggleSidebar }) => {
  const { pathname } = useLocation();
  const { theme } = useTheme();
  console.log("Path...", pathname);

  const sideBarLinks = [
    {
      icon: <SiWindows />,
      name: "Dashboard",
      slug: "/dashboard",
    },
    {
      icon: <IoIosFitness size={20} />,
      name: "Athletes",
      slug: "/athletes",
    },
    {
      icon: <MdPayments size={20} />,
      name: "Payments",
      slug: "/transactions",
    },
    {
      icon: <MdSubscriptions size={20} />,
      name: "Subscriptions",
      slug: "/dashboard/subscriptions",
    },
    {
      icon: <FaCircleUser />,
      name: "Users",
      slug: "/users",
    },
    {
      icon: <RiListSettingsLine size={18} />,
      name: "Features",
      slug: "/feature",
      dropDownArray: [
        {
          subTitle: "Interests",
          subLink: "/feature/interest",
          subIcon: <PiHandHeart />,
        },
        {
          subTitle: "Disciplines",
          subLink: "/feature/discipline",
          subIcon: <TbTargetArrow />,
        },
        {
          subTitle: "Commissions",
          subLink: "/feature/commission-tiers",
          subIcon: <GiProfit />,
        },
      ],
    },
  ];
  return (
    <div className="sticky top-0 z-50 min-h-screen dark:bg-dark2 bg-lightBg ">
      <div className="md:hidden min-w-[80px] w-20 -ml-20   sm:ml-0 content-[' ']"></div>
      <aside
        className={`z-50 md:sticky fixed dark:bg-dark2 bg-lightBg !min-h-screen h-full !top-0 !left-0  ${
          isSidebarCompress
            ? "w-60  ease-linear duration-300 "
            : "w-20 -ml-20  sm:ml-0 ease-linear duration-300"
        }`}
      >
        <div
          className={`cursor-pointer relative h-[96px] p-[23px] flex  items-center  ${
            isSidebarCompress ? "" : ""
          }
        `}
        >
          <Link className="flex items-center justify-center gap-4" to="#">
          {/* image to change  */}
            <img
              src={
                theme === "dark"
                  ? "/Assets/logos/logo_dark.png"
                  : "/Assets/logos/logo_light.png"
              }
              className="max-w-[60px] w-full"
              height={40}
              width={60}
              alt="logo"
            />
          </Link>
        </div>
        <ul className="px-4 py-2 capitalize">
          {sideBarLinks.map((item, index) => {
            const { dropDownArray, icon, slug, name } = item;
            return (
              <>
                {dropDownArray?.length > 0 ? (
                  <Accordion type="single" collapsible>
                    <AccordionItem value="item-1" className={`!border-none  `}>
                      <AccordionTrigger
                        isIcon={false}
                        className={`!no-underline !py-2 ${
                          pathname.includes(slug)
                            ? "bg-primary/20 border-r-8  border-primary text-primary"
                            : "text-[#5C677D]"
                        } relative group hover:bg-primary/20  rounded flex mb-2 ${
                          isSidebarCompress
                            ? "gap-x-2 items-center "
                            : "justify-center "
                        }`}
                      >
                        <div
                          title={name}
                          className={`!no-underline   relative group !px-2 rounded flex   ${
                            isSidebarCompress
                              ? "gap-x-2 items-center"
                              : "justify-center "
                          }`}
                        >
                          <span className="max-w-[30px]">{icon}</span>
                          <span
                            className={`${
                              isSidebarCompress ? "" : "hidden"
                            } font-lato_bold text-sm`}
                          >
                            {name}
                          </span>
                        </div>
                      </AccordionTrigger>
                      <AccordionContent>
                        <div className="flex flex-col gap-2 pl-3">
                          {dropDownArray?.map((ls, index) => {
                            const { subLink, subTitle, subIcon } = ls;
                            return (
                              <Link
                                key={index}
                                to={subLink}
                                title={subTitle}
                                className={`!no-underline w-full text-[#5C677D] relative group hover:bg-primary/20 p-1 rounded flex   ${
                                  isSidebarCompress
                                    ? "gap-x-2 items-center"
                                    : "justify-center "
                                }`}
                              >
                                <span className="max-w-[30px]">{subIcon}</span>
                                <span
                                  className={`${
                                    isSidebarCompress ? "" : "hidden"
                                  } font-lato_bold text-sm`}
                                >
                                  {subTitle}
                                </span>
                              </Link>
                            );
                          })}
                        </div>
                      </AccordionContent>
                    </AccordionItem>
                  </Accordion>
                ) : (
                  <li key={index} className="py-2 ">
                    <Link
                      title={name}
                      className={`${
                        pathname === slug
                          ? "bg-primary/20 border-r-8  border-primary text-primary"
                          : "text-[#5C677D]"
                      } relative group hover:bg-primary/20 p-2 rounded flex mb-1  ${
                        isSidebarCompress
                          ? "gap-x-2 items-center "
                          : "justify-center "
                      }`}
                      to={slug}
                    >
                      <span className="max-w-[30px]">{item?.icon}</span>

                      <span
                        className={`${
                          isSidebarCompress ? "" : "hidden"
                        } font-lato_bold text-sm`}
                      >
                        {name}
                      </span>
                    </Link>
                  </li>
                )}
              </>
            );
          })}
        </ul>
      </aside>
      {/* <div className="bg-dark2  overflow-hidden  !h-screen">
      </div> */}
    </div>
  );
};

export default Sidebar;
